import Stack from "@mui/material/Stack";
import { verifyEmail } from "../api/auth";
import { useState, useEffect } from "react";
import { Theme } from "../data/style/Theme";
import * as routes from "../data/links/routes";
import { CircularProgress } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import VerifiedIcon from "@mui/icons-material/Verified";
import DangerousIcon from "@mui/icons-material/Dangerous";
import { CenteredRow, MainText, FormButton } from "../data/style/Style";

const VerifyEmail = () => {
  const { token } = useParams();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    mutate({ token });
  }, []);

  const { mutate, isPending } = useMutation({
    mutationFn: verifyEmail,
    onSuccess: () => setVerified(true),
    onError: () => setVerified(false),
  });

  return (
    <Stack gap={3} height={"40vh"} maxWidth={"300px"} width={"75%"}>
      {isPending ? (
        <Stack gap={3} alignItems={"center"}>
          <CircularProgress sx={{ color: Theme.palette.orange }} />
          <MainText>Verifing your email...</MainText>
        </Stack>
      ) : verified ? (
        <Stack gap={2}>
          <CenteredRow gap={1}>
            <VerifiedIcon
              sx={{ fontSize: "1.5rem", color: Theme.palette.up }}
            />
            <MainText>Your email has been verified.</MainText>
          </CenteredRow>
          <Link style={{ textDecoration: "none" }} to={routes.LOGIN}>
            <FormButton>
              <MainText>Log in</MainText>
            </FormButton>
          </Link>
        </Stack>
      ) : (
        <CenteredRow gap={1}>
          <DangerousIcon
            sx={{ fontSize: "1.5rem", color: Theme.palette.down }}
          />
          <MainText sx={{ color: Theme.palette.down }}>
            Error verifing your email. Please try again.
          </MainText>
        </CenteredRow>
      )}
    </Stack>
  );
};
export default VerifyEmail;
